import React, { useCallback } from 'react'
import { Divider, Grid, Typography } from '@mui/material'
import { AnyInput, AnyUploader, useValidatedForm } from '../anyform'
import { DialogPopup } from '../components'
import { translate } from '../i18n'
import { ProjectSplash } from '../model'
import { SplashScreenFormProps } from './SplashScreenForm.types'

function SplashScreenForm({
    current,
    s3Client,
    onUpdated,
    onClose,
}: SplashScreenFormProps) {
    const { isValid, register, bind } = useValidatedForm<ProjectSplash>()

    const onUpdate = useCallback(() => {
        if (!isValid()) return

        onUpdated(bind())
    }, [isValid, bind, onUpdated])

    return (
        <DialogPopup
            open
            title={translate('projects.splash.title')}
            maxWidth="sm"
            fullWidth
            disableBackdropClick
            disableEscapeKeyDown
            onClose={onClose}
            button={{
                text: translate('buttons.update'),
                onClick: onUpdate,
            }}
        >
            <Grid container sx={{ mb: 1 }}>
                <Grid item xs={12}>
                    <Typography variant="subtitle1" gutterBottom>
                        {translate('projects.splash.logo') as string}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <AnyUploader
                        name="logo"
                        label={translate('projects.splash.image') as string}
                        s3Client={s3Client}
                        initialValue={current?.logo}
                        acceptExtension={'.jpg,.png'}
                        path="logos"
                        required
                        register={register}
                    />
                    <AnyInput
                        type="text"
                        name="logo_size"
                        initialValue={current?.logo_size ?? ''}
                        label={translate('projects.splash.logo_size') as string}
                        disabled={current?.logo !== undefined}
                        register={register}
                    />
                    <AnyInput
                        type="text"
                        name="logo_position"
                        initialValue={current?.logo_position ?? ''}
                        label={
                            translate('projects.splash.logo_position') as string
                        }
                        disabled={current?.logo !== undefined}
                        register={register}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Divider sx={{ pt: 2, mb: 1 }} />
                    <Typography variant="subtitle1" gutterBottom>
                        {translate('projects.splash.background') as string}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <AnyUploader
                        name="background"
                        label={translate('projects.splash.image') as string}
                        s3Client={s3Client}
                        initialValue={current?.background}
                        acceptExtension={'.jpg,.png,.svg'}
                        path="splash-screens"
                        required
                        register={register}
                    />
                </Grid>
            </Grid>
        </DialogPopup>
    )
}

export default SplashScreenForm
